import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  constructor() { }

  validateDateRange(startDate, endDate) {

    if (!startDate || !endDate) {
      return "Start and End date are required.";
    }

    const start = new Date(startDate);
    const end = new Date(endDate);

    const timeDifference = end.getTime() - start.getTime();

    // Convert time difference to days
    const dayDifference = timeDifference / (1000 * 3600 * 24);

    // Check if the difference is greater than 90 days
    if (dayDifference > 90) {
      return "Please select a date range of 90 days or less.";
    }

    return "valid";
  }

  convertSecondsToReadableFormat(seconds: number): string {
    if (seconds < 60) {
      // Less than 60 seconds

      return seconds == -1 ? "No limit" : `${seconds}s`;
    } else if (seconds < 3600) {
      // Less than 1 hour
      const minutes = seconds / 60;
      return minutes >= 10
        ? `${Math.round(minutes)}m`
        : `${minutes.toFixed(1)}m`;
    } else {
      // 1 hour or more
      const hours = seconds / 3600;
      return hours >= 10
        ? `${Math.round(hours)}h`
        : `${hours.toFixed()}h`;
    }
  }

  downloadAsCSV(data: string, filename: string) {
    const csvFile = new Blob([data], { type: 'text/csv' });
    const link = document.createElement('a');
    if (link.download !== undefined) {
      const url = URL.createObjectURL(csvFile);
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  extractTableData(tableId: string): string[] {
    const table = document.getElementById(tableId) as HTMLTableElement;
    let csv = [];
    for (let i = 0; i < table.rows.length; i++) {
      const row = [];
      for (let j = 0; j < table.rows[i].cells.length; j++) {
        const cellData = table.rows[i].cells[j].innerText;
        if (cellData.includes(',')) {
          row.push('"' + cellData.replace(/"/g, '""') + '"');
        } else {
          row.push(cellData);
        }
      }
      csv.push(row.join(','));
    }

    return csv;
  }



  isValidInt64Str(value: string): boolean {
    if (!/^-?\d+$/.test(value)) return false;
    if (value.length < 19) return true;

    const maxInt64 = "9223372036854775807";
    const minInt64 = "-9223372036854775808";

    if (value.startsWith("-")) {
      return value.length < 20 || value <= minInt64;
    } else {
      return value <= maxInt64;
    }
  }

  convertTo12HourFormat(time24: string): string {
    if (!time24) return '';

    const timeParts = time24.split(':');
    if (timeParts.length < 2) return time24;

    let hours = parseInt(timeParts[0], 10);
    const minutes = timeParts[1];

    if (isNaN(hours) || hours < 0 || hours > 23) return time24;

    const period = hours >= 12 ? 'PM' : 'AM';

    if (hours === 0) {
      hours = 12;
    } else if (hours > 12) {
      hours = hours - 12;
    }
    return `${hours}:${minutes} ${period}`;
  }

  convertDayName(dayNum: number): string {
    if (isNaN(dayNum)) return 'Invalid day';
    dayNum -= 1;
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    return (dayNum >= 0 && dayNum <= 6) ? days[dayNum] : 'Invalid day';
  }


}
